import { supabase } from "@/integrations/supabase/client";
import type { PdfAnnotation, PdfAnnotationType } from "./types";
import type { NormRect } from "../selection/types";

export async function listPdfAnnotations(contentId: string): Promise<PdfAnnotation[]> {
  const { data, error } = await supabase
    .from("pdf_annotations")
    .select("*")
    .eq("content_id", contentId)
    .order("created_at", { ascending: true });

  if (error) throw error;

  return (data ?? []).map((row) => ({
    id: row.id,
    contentId: row.content_id,
    userId: row.user_id,
    pageNumber: row.page_number,
    text: row.text,
    rects: row.rects_norm as NormRect[],
    type: row.type as PdfAnnotationType,
    payload: (row.payload as PdfAnnotation["payload"]) ?? {},
    createdAt: row.created_at,
  }));
}

export async function createPdfAnnotation(input: {
  contentId: string;
  userId: string;
  pageNumber: number;
  text: string;
  rects: NormRect[];
  type: PdfAnnotationType;
  payload: PdfAnnotation["payload"];
}) {
  const { data, error } = await supabase
    .from("pdf_annotations")
    .insert({
      content_id: input.contentId,
      user_id: input.userId,
      page_number: input.pageNumber,
      text: input.text,
      rects_norm: input.rects,
      type: input.type,
      payload: input.payload,
    })
    .select("*")
    .single();

  if (error) throw error;
  return data;
}

export async function deletePdfAnnotation(id: string) {
  const { error } = await supabase.from("pdf_annotations").delete().eq("id", id);
  if (error) throw error;
}
